import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isPremium, setIsPremium] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeFirestore = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      
      if (user) {
        let isFirstSnapshot = true;
        // Listen to user document in Firestore for premium status and profile data
        unsubscribeFirestore = onSnapshot(
          doc(db, "users", user.uid),
          (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              setIsPremium(data.isPremium === true);
              setUserData(data);
            } else {
              setIsPremium(false);
              setUserData(null);
            }
            if (isFirstSnapshot) {
              setLoading(false);
              isFirstSnapshot = false;
            }
          },
          (error) => {
            console.error("Error reading user document:", error);
            setIsPremium(false);
            setUserData(null);
            if (isFirstSnapshot) {
              setLoading(false);
              isFirstSnapshot = false;
            }
          }
        );
      } else {
        setIsPremium(false);
        setUserData(null);
        if (unsubscribeFirestore) unsubscribeFirestore();
        setLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeFirestore) unsubscribeFirestore();
    };
  }, []);

  const value = {
    currentUser,
    isPremium,
    userData,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
